export const GLOBAL_STYLES = `
  * { box-sizing: border-box; margin: 0; padding: 0; }

  :root {
    --red: #e23636;
    --gold: #f0b429;
    --dark: #0a0a0f;
    --panel: #12121c;
    --panel2: #1a1a2e;
    --border: rgba(226,54,54,0.35);
    --text: #e8e8f0;
    --muted: #888;
    --glow: 0 0 20px rgba(226,54,54,0.5);
    --glow-gold: 0 0 20px rgba(240,180,41,0.5);
  }

  html, body, #root {
    height: 100%;
    background: var(--dark);
    font-family: 'Exo 2', sans-serif;
    color: var(--text);
  }

  .app {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    position: relative;
  }

  .bg-hex {
    position: fixed;
    inset: 0;
    background:
      radial-gradient(ellipse at 20% 50%, rgba(226,54,54,0.07) 0%, transparent 60%),
      radial-gradient(ellipse at 80% 20%, rgba(240,180,41,0.05) 0%, transparent 50%),
      repeating-linear-gradient(60deg, transparent, transparent 60px, rgba(226,54,54,0.03) 60px, rgba(226,54,54,0.03) 61px),
      repeating-linear-gradient(-60deg, transparent, transparent 60px, rgba(226,54,54,0.03) 60px, rgba(226,54,54,0.03) 61px);
    pointer-events: none;
    z-index: 0;
  }

  .card {
    background: linear-gradient(135deg, var(--panel) 0%, var(--panel2) 100%);
    border: 1px solid var(--border);
    border-radius: 12px;
    position: relative;
    z-index: 1;
  }

  .card::before {
    content: '';
    position: absolute;
    inset: -1px;
    border-radius: 13px;
    background: linear-gradient(135deg, rgba(226,54,54,0.4), transparent, rgba(240,180,41,0.2));
    z-index: -1;
    pointer-events: none;
  }

  .btn {
    font-family: 'Bebas Neue', sans-serif;
    letter-spacing: 2px;
    font-size: 18px;
    padding: 12px 28px;
    border: 1px solid var(--red);
    background: transparent;
    color: var(--text);
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.2s;
    position: relative;
    overflow: hidden;
  }
  .btn::after { content: ''; position: absolute; inset: 0; background: var(--red); opacity: 0; transition: opacity 0.2s; }
  .btn:hover::after { opacity: 0.15; }
  .btn:hover { box-shadow: var(--glow); border-color: var(--red); }
  .btn:active { transform: scale(0.97); }

  .btn-primary { background: var(--red); border-color: var(--red); color: white; }
  .btn-primary:hover { background: #c62828; box-shadow: var(--glow); }

  .btn-gold { border-color: var(--gold); color: var(--gold); }
  .btn-gold:hover { box-shadow: var(--glow-gold); }

  .title { font-family: 'Bebas Neue', sans-serif; letter-spacing: 4px; line-height: 1; }

  .divider { height: 1px; background: linear-gradient(90deg, transparent, var(--red), transparent); margin: 16px 0; }

  /* Menu */
  .menu-wrap { max-width: 540px; width: 100%; }
  .logo-area { text-align: center; margin-bottom: 32px; }
  .logo-main { font-size: clamp(48px, 10vw, 80px); color: var(--red); text-shadow: 0 0 40px rgba(226,54,54,0.6); display: block; }
  .logo-sub { font-size: clamp(16px, 4vw, 26px); color: var(--gold); letter-spacing: 8px; }
  .byline { font-size: 13px; color: var(--muted); letter-spacing: 4px; text-transform: uppercase; margin-top: 8px; font-family: 'Rajdhani', sans-serif; }

  .diff-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 20px; }
  .diff-btn { padding: 18px 12px; border-radius: 8px; border: 1px solid; background: transparent; cursor: pointer; transition: all 0.2s; font-family: 'Bebas Neue', sans-serif; letter-spacing: 3px; font-size: 20px; }
  .diff-btn .diff-desc { display: block; font-family: 'Exo 2', sans-serif; font-size: 11px; letter-spacing: 1px; margin-top: 4px; opacity: 0.7; text-transform: uppercase; }
  .diff-easy { border-color: #4caf50; color: #4caf50; }
  .diff-easy.selected, .diff-easy:hover { background: rgba(76,175,80,0.15); box-shadow: 0 0 16px rgba(76,175,80,0.4); }
  .diff-medium { border-color: #2196f3; color: #2196f3; }
  .diff-medium.selected, .diff-medium:hover { background: rgba(33,150,243,0.15); box-shadow: 0 0 16px rgba(33,150,243,0.4); }
  .diff-hard { border-color: var(--red); color: var(--red); }
  .diff-hard.selected, .diff-hard:hover { background: rgba(226,54,54,0.15); box-shadow: var(--glow); }
  .diff-impossible { border-color: var(--gold); color: var(--gold); }
  .diff-impossible.selected, .diff-impossible:hover { background: rgba(240,180,41,0.1); box-shadow: var(--glow-gold); }

  /* Game */
  .game-wrap { max-width: 680px; width: 100%; }
  .game-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; }
  .hud-item { text-align: center; }
  .hud-label { font-size: 10px; letter-spacing: 3px; color: var(--muted); text-transform: uppercase; font-family: 'Rajdhani', sans-serif; }
  .hud-val { font-family: 'Bebas Neue', sans-serif; font-size: 28px; letter-spacing: 2px; }

  .timer-ring { position: relative; width: 68px; height: 68px; }
  .timer-ring svg { transform: rotate(-90deg); }
  .timer-ring .timer-num { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; font-family: 'Bebas Neue', sans-serif; font-size: 24px; }

  .q-card { padding: 28px; margin-bottom: 18px; }
  .q-meta { font-size: 11px; letter-spacing: 3px; color: var(--muted); text-transform: uppercase; margin-bottom: 10px; font-family: 'Rajdhani', sans-serif; }
  .q-text { font-size: clamp(16px, 3vw, 22px); font-weight: 700; line-height: 1.4; }

  .choices { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
  .choice-btn { padding: 14px 12px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.03); color: var(--text); border-radius: 8px; cursor: pointer; font-family: 'Exo 2', sans-serif; font-size: 14px; font-weight: 500; text-align: left; transition: all 0.15s; line-height: 1.3; }
  @media (hover: hover) { .choice-btn:hover { border-color: rgba(226,54,54,0.5); background: rgba(226,54,54,0.08); } }
  .choice-btn.correct { border-color: #4caf50; background: rgba(76,175,80,0.2); color: #81c784; }
  .choice-btn.wrong { border-color: var(--red); background: rgba(226,54,54,0.2); color: #ef9a9a; }
  .choice-btn:disabled { cursor: default; }

  .progress-bar-wrap { height: 4px; background: rgba(255,255,255,0.08); border-radius: 2px; margin-bottom: 16px; }
  .progress-bar-fill { height: 100%; background: linear-gradient(90deg, var(--red), var(--gold)); border-radius: 2px; transition: width 0.3s; }

  .exit-btn { font-family: 'Rajdhani', sans-serif; font-size: 13px; letter-spacing: 2px; padding: 6px 16px; border: 1px solid rgba(255,255,255,0.15); background: transparent; color: var(--muted); cursor: pointer; border-radius: 4px; transition: all 0.2s; text-transform: uppercase; }
  .exit-btn:hover { border-color: var(--red); color: var(--red); }

  /* Round/Game End */
  .round-wrap { max-width: 500px; width: 100%; text-align: center; padding: 36px; }
  .big-score { font-family: 'Bebas Neue', sans-serif; font-size: 80px; color: var(--gold); line-height: 1; }

  /* Leaderboard */
  .lb-wrap { max-width: 540px; width: 100%; }
  .lb-row { display: flex; align-items: center; gap: 14px; padding: 12px 16px; border-bottom: 1px solid rgba(255,255,255,0.05); }
  .lb-rank { font-family: 'Bebas Neue', sans-serif; font-size: 22px; width: 36px; text-align: center; }
  .lb-name { flex: 1; font-weight: 600; font-size: 15px; }
  .lb-score { font-family: 'Bebas Neue', sans-serif; font-size: 22px; color: var(--red); }
  .lb-diff { font-size: 10px; letter-spacing: 2px; color: var(--muted); text-transform: uppercase; }

  .name-input { background: rgba(255,255,255,0.05); border: 1px solid var(--border); border-radius: 6px; color: var(--text); font-family: 'Exo 2', sans-serif; font-size: 18px; padding: 12px 16px; width: 100%; text-align: center; outline: none; transition: border-color 0.2s; }
  .name-input:focus { border-color: var(--red); box-shadow: var(--glow); }

  @keyframes fadeIn { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
  .fade-in { animation: fadeIn 0.4s ease both; }
`;
